module.exports = __webpack_public_path__ + "img/SV.b958977f.svg";